import { defineComponent } from 'vue'
import type { PropType, ExtractPropTypes } from 'vue'

export const edittableColumnLinkProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  // 是否可编辑
  editable: Boolean,
  cellEditable: Boolean,
})

export type EdittableColumnLinkProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnLinkProps>>>

export default defineComponent({
  name: 'OEdittableColumnCheckbox',
  inheritAttrs: false,
  props: edittableColumnLinkProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
